import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import {
  Bank,
  BankListItem,
  ApiResponse,
} from '@/api/types'

/**
 * Bank management service
 */
export class BankService {
  /**
   * Get all banks for a branch
   */
  async getAllBanks(branchId?: number): Promise<BankListItem[]> {
    const url = endpoints.banks.getAll(branchId)
    const response = await apiClient.get<ApiResponse<BankListItem[]> | BankListItem[] | any>(url)
    const payload = response.data

    if (payload && typeof payload === 'object') {
      if ('success' in payload && 'data' in payload) {
        return payload.data as BankListItem[]
      }
      if ('data' in payload && Array.isArray(payload.data)) {
        return payload.data as BankListItem[]
      }
    }

    if (Array.isArray(payload)) {
      return payload as BankListItem[]
    }

    return []
  }

  /**
   * Get bank by ID
   */
  async getBankById(id: number): Promise<Bank> {
    const url = endpoints.banks.getById(id)
    const response = await apiClient.get<ApiResponse<Bank> | Bank | any>(url)
    const payload = response.data

    if (payload && typeof payload === 'object') {
      if ('success' in payload && 'data' in payload) {
        return payload.data as Bank
      }
      if ('data' in payload) {
        return payload.data as Bank
      }
    }

    return payload as Bank
  }

  /**
   * Get banks by employee ID
   */
  async getBanksByEmpId(empId: number): Promise<BankListItem[]> {
    const url = endpoints.banks.getByEmpId(empId)
    const response = await apiClient.get<ApiResponse<BankListItem[]> | BankListItem[] | any>(url)
    const payload = response.data

    if (payload && typeof payload === 'object') {
      if ('success' in payload && 'data' in payload) {
        return payload.data as BankListItem[]
      }
      if ('data' in payload && Array.isArray(payload.data)) {
        return payload.data as BankListItem[]
      }
    }

    if (Array.isArray(payload)) {
      return payload as BankListItem[]
    }

    return []
  }

  /**
   * Save new bank
   */
  async saveBank(bank: Bank): Promise<any> {
    const url = endpoints.banks.save
    const response = await apiClient.post(url, bank)
    return response.data
  }

  /**
   * Update existing bank
   */
  async updateBank(bank: Bank): Promise<any> {
    const url = endpoints.banks.update
    const response = await apiClient.put(url, bank)
    return response.data
  }

  /**
   * Delete bank
   */
  async deleteBank(id: number): Promise<any> {
    const url = endpoints.banks.delete(id)
    const response = await apiClient.delete(url)
    return response.data
  }
}

export const bankService = new BankService()
